// extracted by mini-css-extract-plugin
export default {"checkbox":"SquareCheckbox_checkbox__62I7u","disabled":"SquareCheckbox_disabled__UMNn3"};